import { OPERATIONS_SERVICE } from "@/services/operations.service.js";
import router from '@/router/index';

const state = { listOutput: {}, listSummaryOutput: {}, listCostsSummary: {}, comparativeData: {}, operationOutput: {}, removeTask: undefined, exportExcelOutput: undefined, saveStartDate: null, saveEndDate: null};

const actions = {
    getList({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        OPERATIONS_SERVICE.list(input.resultsNumber, input.pageNumber, input.startDate, input.endDate, input.task, input.place, input.person, input.tool, input.orderBy)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getListSummary({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('listSummaryRequest');
        
        OPERATIONS_SERVICE.listSummary()
            .then(
                output => {
                    commit('listSummarySuccess', output);
                },
                error => {
                    commit('listSummaryFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getListCosts({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('listCostsRequest');
        
        OPERATIONS_SERVICE.listCosts(input.startTime, input.endTime, input.task, input.place, input.person, input.tool)
            .then(
                output => {
                    commit('listCostsSuccess', output);
                },
                error => {
                    commit('listCostsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getComparativeData({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('getComparativeDataRequest');
        
        OPERATIONS_SERVICE.getComparativeData(input.startTime, input.endTime, input.orderBy, input.orderByType)
            .then(
                output => {
                    commit('getComparativeDataSuccess', output);
                },
                error => {
                    commit('getComparativeDataFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getOperation({ dispatch, commit }, operationId) {
        dispatch('alert/clear', null, { root: true });
        commit('getRequest');

        OPERATIONS_SERVICE.get(operationId)
            .then(
                output => {
                    commit('getSuccess', output);
                },
                error => {
                    commit('getFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    addOperation({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('addRequest');
  
        OPERATIONS_SERVICE.add(input.operation)
            .then(
                output => {
                    commit('addSuccess', output);
                },
                error => {
                    commit('addFailure', error);
                    dispatch('alert/error', error, { root: true });

                }
                
            );

    },
    removeOperation({ dispatch, commit }, operationId) {
        dispatch('alert/clear', null, { root: true });
        commit('removeRequest');

        OPERATIONS_SERVICE.remove(operationId)
            .then(
                output => {
                    commit('removeSuccess');
                },
                error => {
                    commit('removeFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    exportExcel({ dispatch, commit }, input){
        dispatch('alert/clear', null, { root: true });
        commit('exportExcelRequest');


        OPERATIONS_SERVICE.exportExcel(input.startDate, input.endDate, input.task, input.place, input.person, input.tool)
            .then(
                result => {
                    commit('exportExcelSuccess', result);
                },
                error => {
                    commit('exportExcelFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    updateFirstDate({commit}, payload) {
        commit('updateFirstDateSuccess', payload)
    },
    updateEndDate({commit}, payload) {
        commit('updateEndDateSuccess', payload)
    }
}

const mutations = {
    /* List */
    listRequest(state) {
        //
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = {};
    },
    /* List Summary */
    listSummaryRequest(state) {
        //
    },
    listSummarySuccess(state, output) {
        state.listSummaryOutput = output;
    },
    listSummaryFailure(state) {
        state.listSummaryOutput = {};
    },
    /* List */
    listCostsRequest(state) {
        //
    },
    listCostsSuccess(state, output) {
        state.listCostsSummary = output;
    },
    listCostsFailure(state) {
        state.listCostsSummary = {};
    },
    /* Comparative data */
    getComparativeDataRequest(state) {
        //
    },
    getComparativeDataSuccess(state, output) {
        state.comparativeData = output;
    },
    getComparativeDataFailure(state) {
        state.comparativeData = {};
    },
    /* Get */
    getRequest(state) {
        //
    },
    getSuccess(state, output) {
        state.operationOutput = output;
    },
    getFailure(state) {
        state.operationOutput = {};
    },
    /* Add */
    addRequest(state) {
    },
    addSuccess(state) {
        router.push('/operacoes/lista');
    },
    addFailure(state) {
        //
    },
    /* Remove */
    removeRequest(state) {
        state.removeTask = undefined;
    },
    removeSuccess(state) {
        state.removeTask = true;
    },
    removeFailure(state) {
        state.removeTask = false;
    },
    /* Export to excel */
    exportExcelRequest(state) {
        state.exportExcelOutput = undefined;
    },
    exportExcelSuccess(state) {
        state.exportExcelOutput = true;
    },
    exportExcelFailure(state) {
        state.exportExcelOutput = false;
    },
    /* keep the filter information */ 
    updateFirstDateSuccess(state, payload) {
        state.saveStartDate = payload;
     },
     updateEndDateSuccess(state, payload) {
        state.saveEndDate = payload; 
     }
}

export const operations = {
    namespaced: true,
    state,
    actions,
    mutations
};